import { render, staticRenderFns } from "./DelegacionTomaDecisiones.vue?vue&type=template&id=9506b0d4&"
import script from "./DelegacionTomaDecisiones.vue?vue&type=script&lang=js&"
export * from "./DelegacionTomaDecisiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports